import React, { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Task, TASK_COLOR } from '@repo/shared';

import { Badge } from '@/components/ui/badge';

interface TaskBadgeProps {
  task: Task;
}

const TaskBadge: FC<TaskBadgeProps> = ({ task }) => {
  const { t } = useTranslation();

  const label = useMemo(() => {
    switch (task) {
      case Task.TEXT_TRANSLATION:
        return t('enums.task.textTranslation');
      case Task.EXTRACT_STRUCTURE:
        return t('enums.task.extractStructure');
      case Task.DESCRIBE_IMAGE:
        return t('enums.task.describeImage');
      case Task.GENERATE_AUDIO:
        return t('enums.task.generateAudio');
      default:
        return null;
    }
  }, [task, t]);

  return <Badge style={{ backgroundColor: TASK_COLOR[task] }}>{label}</Badge>;
};

export default TaskBadge;
